import { useLayoutEffect, useState } from 'react';

export interface IWindowDimensions {
  width: number;
  height: number;
}

export const useWindowDimensions = (): IWindowDimensions => {
  const [dimensions, setDimensions] = useState<IWindowDimensions>({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  const updateDimensions = (): void => {
    setDimensions({ width: window.innerWidth, height: window.innerHeight });
  };

  useLayoutEffect(() => {
    window.addEventListener('resize', updateDimensions);
    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  return dimensions;
};
